import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import Logo from "./Logo.png";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("sessionToken");
    window.location.href = "/dashboard";
  };

  const navItems = [
    { path: "/ContactUs", label: "Contact Us" },
    { path: "/Book_now", label: "Book Now" },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
          my: 2,
        }}
      >
        <Box
          component="img"
          src={Logo}
          alt="Logo"
          sx={{
            height: 50,
            width: "auto",
            objectFit: "contain",
          }}
        />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Admin KTS4U
        </Typography>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                textAlign: "center",
                "&.Mui-selected": {
                  backgroundColor: "rgba(42, 82, 152, 0.1)",
                  color: "#2a5298",
                },
              }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton
            onClick={handleLogout}
            sx={{
              textAlign: "center",
              color: "#ed0e28",
              fontWeight: 600,
              borderRadius: "8px",
              mx: 1.5,
              mt: 1,
              mb: 1,
              border: "1px solid rgba(237, 14, 40, 0.3)",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#ed0e28",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0px 4px 12px rgba(237, 14, 40, 0.3)",
              },
            }}
          >
            <LogoutIcon sx={{ mr: 1.5 }} />
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{
                fontWeight: 600,
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="static"
        sx={{
          background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              component="img"
              src={Logo}
              alt="Logo"
              sx={{
                height: { xs: 32, sm: 40 },
                width: "auto",
                objectFit: "contain",
              }}
            />
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1rem", sm: "1.25rem" },
                display: { xs: "none", sm: "block" },
              }}
            >
              Admin KTS4U
            </Typography>
          </Box>

          <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 2 }}>
            {navItems.map((item) => (
              <Button
                key={item.path}
                component={Link}
                to={item.path}
                sx={{
                  color: "white",
                  fontWeight: location.pathname === item.path ? 700 : 500,
                  textTransform: "none",
                  fontSize: "1rem",
                  borderBottom:
                    location.pathname === item.path
                      ? "2px solid white"
                      : "2px solid transparent",
                  borderRadius: 0,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderBottom: "2px solid white",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
            <Button
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
              variant="outlined"
              sx={{
                color: "white",
                borderColor: "rgba(255, 255, 255, 0.5)",
                textTransform: "none",
                fontSize: "0.95rem",
                fontWeight: 600,
                ml: 2,
                px: 2.5,
                py: 0.75,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(237, 14, 40, 0.9)",
                  borderColor: "#ed0e28",
                  color: "white",
                  transform: "translateY(-2px)",
                  boxShadow: "0px 4px 12px rgba(237, 14, 40, 0.4)",
                },
              }}
            >
              Logout
            </Button>
          </Box>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 250,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;
